import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

interface SwitchProps {
  label: string;
  isChecked: boolean;
  onToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const SwitchContainer = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  
  background: none;
  border: none;
  
  padding: 8px;
  border-radius: 4px;
  
  &:hover {background: rgba(240, 229, 222, 1)}
`;

const Label = styled.span`
  margin-right: 10px;
  font-size: 12px;
  color: rgba(57, 29, 10, 1);
`;

const SwitchWrapper = styled.div`
  position: relative;
  width: 28px;
  height: 16px;
  background: #ccc;
  border-radius: 14px;
`;

const Toggle = styled(motion.div)`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const Switch: React.FC<SwitchProps> = ({ label, isChecked, onToggle }) => {
  return (
    <SwitchContainer onClick={onToggle}>
      <Label>{label}</Label>
      <SwitchWrapper style={{background: isChecked ? '#b29b84' : '#bfbfbf'}}>
        <Toggle
          animate={{ x: isChecked ? 12 : 0 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        />
      </SwitchWrapper>
    </SwitchContainer>
  );
};


export default Switch;
